"use client";

import { cn } from "@ui/lib/utils";
import * as m from "motion/react-m";
import { useState } from "react";

export const GetStartedButtonIllustration = ({ className }: { className?: string }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handlePressDown = () => {
    setIsPressed(true);
  };

  const handlePressUp = () => {
    setIsPressed(false);
  };

  return (
    <div
      aria-hidden='true'
      className={cn("relative cursor-pointer select-none", className)}
      onMouseDown={handlePressDown}
      onMouseLeave={handlePressUp} // Reset if mouse leaves while pressed
      onMouseUp={handlePressUp}
      onTouchEnd={handlePressUp}
      onTouchStart={handlePressDown}
      role='button'
    >
      {/* Bottom layer */}
      <img alt='Button bottom layer' className='relative z-1' src='/assets/images/convai/button/bottom.svg' />

      {/* Middle layer - animated */}
      <m.img
        alt='Button middle layer'
        animate={{
          y: isPressed ? 24 : 0,
        }}
        className='absolute left-0 top-0 z-2'
        initial={{ y: 0 }}
        src='/assets/images/convai/button/middle.svg'
        transition={{
          type: "spring",
          stiffness: 400,
          damping: 28,
        }}
      />

      {/* Top layer */}
      <img alt='Button top layer' className='absolute left-0 top-0 z-3' src='/assets/images/convai/button/top.svg' />
    </div>
  );
};
